import React, { useEffect } from 'react'
import { StyleSheet, TouchableOpacity, View } from 'react-native'
import { TextInputComponent } from '../TextInputComponent'
import { MinusIcon, PlusIcon } from '../Svg'
import { useForm } from '../../hooks/useForm'
import { lightBackground } from '../../theme/colors'

interface Props {
  readonly?: boolean
  initialValue?: number
  label?: string
  symbol?: string
  minValue?: number
  maxValue?: number
  getValue: (value: number) => void
}

export const NumberStepper = ({
  readonly,
  getValue,
  initialValue,
  label,
  symbol,
  maxValue,
  minValue,
}: Props) => {
  const { values, onChangeValues } = useForm<{ quantity: number }>({
    quantity: initialValue ?? 0,
  })

  useEffect(() => {
    onChangeValues({
      name: 'quantity',
      value: initialValue ?? 0,
    })
  }, [initialValue])

  const handleOnChange = (value: string) => {
    if (readonly) return
    const cleanValue = getCleanValue(+value)
    if (!isNaN(Number(cleanValue))) {
      onChangeValues({
        name: 'quantity',
        value: maxValue ? (+cleanValue >= maxValue ? maxValue : cleanValue) : cleanValue,
      })
      return
    }
    onChangeValues({
      name: 'quantity',
      value: '',
    })
  }
  const handleAdd = (value: number) => {
    if (readonly) return

    const cleanValue = getCleanValue(value)

    const newValue = maxValue
      ? +cleanValue >= maxValue
        ? maxValue
        : +cleanValue + 1
      : +cleanValue + 1
    addSymbolToValue(newValue)
  }

  const handleLess = () => {
    if (readonly) return
    const cleanValue = getCleanValue()
    let newValue = cleanValue - 1
    if (minValue !== undefined && newValue < minValue) {
      newValue = minValue
    }
    addSymbolToValue(newValue)
  }

  const addSymbolToValue = (newVale: number) => {
    const value = getCleanValue(newVale)

    onChangeValues({
      name: 'quantity',
      value: `${value} ${symbol ?? ''}`.trim(),
    })
  }

  const getCleanValue = (value = values.quantity): number =>
    +value
      .toString()
      .replace(symbol ?? '', '')
      .trim()

  useEffect(() => {
    getValue(
      +values.quantity
        .toString()
        .replace(symbol ?? '', '')
        .trim(),
    )
  }, [values])
  return (
    <View style={{ flexDirection: 'row', flex: 1 }}>
      <TextInputComponent
        label={label}
        onChange={handleOnChange}
        value={`${values.quantity}`}
        customStyles={{
          container: { flex: 1 },
          input: [{ textAlign: 'center' }, readonly && { backgroundColor: lightBackground }],
        }}
        keyboardType='numeric'
        placeholder=''
        onBlur={() => addSymbolToValue(values.quantity)}
      />
      {!readonly && (
        <>
          <TouchableOpacity style={[styles.item, { left: 0 }]} onPress={handleLess}>
            <MinusIcon height={20} width={20} />
          </TouchableOpacity>

          <TouchableOpacity
            style={[styles.item, { right: 0 }]}
            onPress={() => handleAdd(values.quantity)}
            onBlur={() => addSymbolToValue(values.quantity)}
          >
            <PlusIcon height={20} width={20} />
          </TouchableOpacity>
        </>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  item: {
    position: 'absolute',
    height: 42,
    marginTop: 25,
    width: 35,
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
  },
})
